import Home from "../Components/Home/Home";
import Projects from "../Components/Projects/Projects";
import TechStack from "../Components/TechStack/TechStack";
import AboutMe from "../Components/AboutMe/AboutMe";
import Resume from "../Components/Resume/Resume";
import ContactMe from "../Components/ContactMe/ContactMe";

export const TOTAL_SCREENS = [
  {
    screen_name: "Accueil",
    component: Home,
  },
  {
    screen_name: "Projets",
    component: Projects,
  },
  {
    screen_name: "Tech Stack",
    component: TechStack,
  },
  {
    screen_name: "À Propos",
    component: AboutMe,
  },
  {
    screen_name: "Cursus",
    component: Resume,
  },
  {
    screen_name: "Contact",
    component: ContactMe,
  },
];
export const GET_SCREEN_INDEX = (screen_name) => {
  if (!screen_name) return -1;
  for (let i = 0; i < TOTAL_SCREENS.length; i++) {
    if (TOTAL_SCREENS[i].screen_name === screen_name) return i;
  }
  return -1;
};
